import Tools from '../Tools/Tools';
/**
 * Třída, která zajišťuje propojení inputů nastevení cen.
 */
class PriceThresholds {
	/**
	 * @param {Element} section Sekce DOMu, v které se nachází formulář.
	 * @param {array} zonesSubcategories Podkategorie, které se upravují.
	 */
	constructor(section, zonesSubcategories) {
		this.section = section;
		this.zonesSubcategories = zonesSubcategories;
		this.priceTresholdsInputs = ['minCpt', 'firstlook', 'adblock'];

		if (!this.arePricesEnabled()) {
			return;
		}

		this._connectInputs();
		this._connectRadioButtons();
	}

	/**
	 * Kontroluje zda jsou cenové prahy na stránce.
	 * @return {boolean}
	 */
	arePricesEnabled() {
		return Boolean(this.section.querySelector('.Common-prices-minCpt'));
	}

	/**
	 * Zajistí, že se úpravy inputu v hlavičce propisují do podkategorií.
	 */
	_connectInputs() {
		this.priceTresholdsInputs.forEach((type) => {
			// Inputy v hlavičce, které mohou editovat podkategorie.
			const inputHeader = this.section.querySelector(`input.Common-prices-${type}`);

			inputHeader.addEventListener('input', (e) => {
				this.zonesSubcategories.forEach((subcategory) => {
					const subcategoryInput = this.section.querySelector(`input.${subcategory}-prices-${type}`);

					if (subcategoryInput) {
						subcategoryInput.value = e.target.value;
					}
				});
			});
		});
	}

	/**
	 * Propojí radio button nastavení firstLooku.
	 */
	_connectRadioButtons() {
		// Tlačítka, které umožňují zapnutí/vypnutí inputu firstlook.
		const firstlookRadios = Array.from(this.section.getElementsByClassName('Common-prices-firstlook-radio'));

		this.zonesSubcategories.forEach((subcategory) => {
			firstlookRadios.push(...Array.from(this.section.getElementsByClassName(subcategory + '-prices-firstlook-radio')));
		});

		// Nastavení posluchače na jednotlivé inputy (type=radio).
		firstlookRadios.forEach((radio) => {
			const parentElement = Tools.getParentByClass(radio, 'Column');
			// Input, který bude vypnut/zapnut. Defaultní nastavení.
			const input = parentElement.querySelector('input[type="text"]');

			if (radio.getAttribute('checked') === 'true') {
				input.disabled = radio.getAttribute('value') === 'false';
			}

			radio.addEventListener('click', (e) => {
				const isInputDisabled = e.target.getAttribute('value') === 'false';

				input.disabled = isInputDisabled;

				// Pokud upravuji inputy v headeru, tak se pod podmínkou propisují do podkategorií.
				if (e.target.classList.contains('Common-prices-firstlook-radio')) {
					this.zonesSubcategories.forEach((child) => {
						const enableFirstlook = this.section.querySelector(`input.${child}-prices-firstlook-radio[value=true]`);

						const disableFirstlook = this.section.querySelector(`input.${child}-prices-firstlook-radio[value=false]`);

						if (!enableFirstlook || !disableFirstlook) {
							return;
						}

						const toolParentElement = Tools.getParentByClass(enableFirstlook, 'Column');

						const toolsInput = toolParentElement.querySelector('input[type="text"]');

						toolsInput.disabled = isInputDisabled;
						enableFirstlook.checked = !isInputDisabled;
						// eslint-disable-next-line typescript-eslint/no-unnecessary-type-conversion
						disableFirstlook.checked = !!isInputDisabled;
					});
				}
			});
		});
	}
}

export default PriceThresholds;
